import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import * as checkinActions from "src/actions/checkinActions";

//Material Icons
import CCValidation from "./CCValidation";
import IdVerification from "./IdVerification";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100vw",
        height: "100vh",
    },
    paper: {
        backgroundColor: "transparent",
    },
    iframe: {
        zIndex: 99,
        width: "100vw",
        height: "100vh",
    },
    loadingStatus: { position: "absolute", top: "50%", left: "50%", zIndex: "-1" },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
}));

const TwoStepsVerify = () => {
    const classes = useStyles();

    const checkin = useSelector((state) => state.checkin);
    const isDemo = useSelector((state) => state.checkin.isDemo);
    const isAdditionalDriver = useSelector((state) => state.checkin.isAdditionalDriver);
    const isHCCWorkflow = useSelector((state) => state.checkin.resType === 'HX');

    // const cardValidationStatus = useSelector((state) => state.checkin.windcave);
    const idVerificationStatus = useSelector((state) => state.checkin.idVerification);
    // const licCountry = useSelector((state) => state.checkin.licCountry);

    // const [ccVerified, setCCVerified] = React.useState(false);
    const [ccVerified, setCCVerified] = React.useState(true);
    const [idVerified, setIdVerified] = React.useState(false);
    const [notifiedCIF, setNotifiedCIF] = React.useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    //Get URL PARAMETERS
    const status = new URLSearchParams(window.location.search).get("status");

    React.useEffect(() => {
        const note = checkin?.reservation?.ReservationMainNote ?? "";

        if (
            (idVerificationStatus.Verified &&
                idVerificationStatus.Status === "COMPLETED_PASS" &&
                idVerificationStatus.DocumentVariant !== "LEARNERS"
            ) || 
            (idVerificationStatus.Verified &&
                idVerificationStatus.OverallResult === "PASS" &&
                idVerificationStatus.FaceMatch === "PASS" &&
                idVerificationStatus.Liveness === "PASS" &&
                idVerificationStatus.DVS === "FAIL" &&
                (note.includes("CIW") || note.includes("CIP")) &&
                idVerificationStatus.DocumentVariant !== "LEARNERS"
            )
        ) {
            if (!checkin.requireReVerifyID) {
                setIdVerified(true);
            }
        }
    });

    // React.useEffect(() => {
    //     if (cardValidationStatus.Windcave != null) {
    //         setTimeout(() => {
    //             if (!cardValidationStatus.Windcave.status.includes("APPROVED") || cardValidationStatus.nameMisMatch) {
    //                 updateCarsplusMainNote();
    //             }
    //             setCCVerified(cardValidationStatus.Windcave.status.includes("APPROVED") && !cardValidationStatus.nameMisMatch);

    //         }, 500)

    //     }
    // }, [cardValidationStatus]);

    React.useEffect(() => {
        if (ccVerified && idVerified) {
            navigate(`/${isDemo ? 'checkin-demo' : isAdditionalDriver?'additional-driver-checkin':'checkin'}/checkin-form`, { replace: true });
        }
    }, [ccVerified, idVerified]);

    // React.useEffect(() => {
    //     if(isAdditionalDriver || isHCCWorkflow) {
    //         setCCVerified(true);
    //     }
    // });

    const updateCarsplusMainNote = () => {
        const currentMainNote = _.get(checkin, "reservation.ReservationMainNote", "");
        if (!notifiedCIF) {
            if (currentMainNote.includes("CIF")) {
                console.log('Already updated with CIF');
                return
            }
            const newNote = currentMainNote.slice(0, currentMainNote.indexOf('|CI')) + "|CIF|"
            console.log('updateCarsplusMainNote from windcave fail. newNote:', newNote)
            dispatch(
                checkinActions.updateReservationAndCustomerCIF({

                    resno: checkin.resNo,
                    MainNote: newNote.slice(0,30),
                    CheckedIn: false,
                    CheckinFailed: true,
                    FailType: 'CreditCard',
                    token: checkin.auth.token,
                })
            );
            setNotifiedCIF(true);
        }
    }

    return (
        <React.Fragment>
            <div style={{ maxWidth: 600, padding: 20, height: "90vh" }}>
                {{
                    ['true-false']: <IdVerification setIdVerified={setIdVerified} />,
                    ['false-true']: <CCValidation />,
                    ['false-false']: <CCValidation />,

                }[`${ccVerified}-${idVerified}`]}
            </div>
        </React.Fragment>
    );
};

export default TwoStepsVerify;
